module.exports = __webpack_public_path__ + "img/pickiddo-logo.0c318100.png";